import {useMutation} from "@tanstack/react-query";
import {readShipmentExchangeRate} from "../../../../../api/order/OrdersApi";
import {OrdersShipmentExchangeRateSearchParamType} from "../interface";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";

export const useReadShipmentExchangeRate = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: OrdersShipmentExchangeRateSearchParamType) => readShipmentExchangeRate(data),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
